export const Unit = {
    METRIC: "metric",
    IMPERIAL: "imperial"
}